import HomeComment from "components/home/home_comment";
import HomeMenuSectionComponent from "components/home/home_menu_selection";
import { CheckWithPrefixResponse } from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import { GetAllContentByPrefixResponse } from "lib/worker/api/get_all_content_by_prefix";
import { GetPromotionTypesResponse } from "lib/worker/api/get_promotion_types";
import { GetVenderDomainInfomationResponse } from "lib/worker/api/get_vender_domain_infomation";
import { connect } from "react-redux";
import FooterSnam from "../view/footer_snam";
import HomeBannerComponent from "./home_banner";
import HomeContentAbout from "./home_content_about";
import HomeContentArticle from "./home_content_article";
import HomeContentUfabet from "./home_content_ufabet";
import HomeInviteFriend from "./home_invite_friend";
import HomeJackpot from "./home_jackpot";
import HomeLogo from "./home_logo";
import HomeStatusMemberCompoment from "./home_status_member";
import HomeUgameSpeed from "./home_ugame_speed";

interface HomeProps {
  state: AppReducerStateProps;
  venderInfomation: GetVenderDomainInfomationResponse;
  content: GetAllContentByPrefixResponse[];
  infomation: CheckWithPrefixResponse;
  promotions: GetPromotionTypesResponse[];
}

function Home(_props: HomeProps) {
  const { isLogin } = _props.state.member;

  return (
    <>
      <div className="container" style={{ paddingTop: 5 }}>
        <HomeLogo infomation={_props.infomation}></HomeLogo>
      </div>

      <div className="container">
        {!isLogin && (
          <div className="margin-top-10 margin-bottom-10">
            <HomeBannerComponent
              infomation={_props.infomation}
            ></HomeBannerComponent>
          </div>
        )}
      </div>

      <div className="container">
        {isLogin && (
          <>
            <HomeStatusMemberCompoment
              infomation={_props.infomation}
            ></HomeStatusMemberCompoment>
          </>
        )}
      </div>

      <div className="container">
        <HomeMenuSectionComponent
          isLoading={false}
          infomation={_props.infomation}
        ></HomeMenuSectionComponent>
      </div>
      <div className="container">
        <HomeJackpot information={_props.infomation}></HomeJackpot>
      </div>
      <div className="container margin-top-10">
        <HomeUgameSpeed></HomeUgameSpeed>
      </div>

      {!isLogin && (
        <div className="margin-top-10 margin-bottom-10 container">
          <HomeContentArticle
            infomation={_props.infomation}
          ></HomeContentArticle>
        </div>
      )}

      <div className="container margin-top-20">
        <HomeInviteFriend infomation={_props.infomation}></HomeInviteFriend>
      </div>

      <div className="container">
        <HomeComment infomation={_props.infomation}></HomeComment>
      </div>

      <div className="container">
        <HomeContentAbout infomation={_props.infomation}></HomeContentAbout>
      </div>

      <div className="container">
        <HomeContentUfabet></HomeContentUfabet>
      </div>

      <div className="container">
        <FooterSnam></FooterSnam>
      </div>
    </>
  );
}

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(Home);
